import { FormattedMessage } from "react-intl";
import { CardActions, CardContent } from "@mui/material";
import { RefetchOptions } from "@tanstack/react-query";

import { formatItemHtmlList } from "@framework/exchange";
import { IToken, ModuleType } from "@framework/types";

import { MysteryWrapperUnpackButton } from "../../../../../../components/buttons";
import { StyledCard, StyledList, StyledToolbar, StyledTypography } from "./styled";

export interface IMysteryTokenPanelProps {
  token: IToken;
  onRefreshPage: (options?: RefetchOptions) => Promise<any>;
}

export const MysteryTokenPanel = (props: IMysteryTokenPanelProps) => {
  const { token, onRefreshPage } = props;

  if (token.template?.contract?.contractModule !== ModuleType.MYSTERY) {
    return null;
  }

  return (
    <StyledCard>
      <CardContent>
        <StyledToolbar disableGutters>
          <StyledTypography gutterBottom variant="h5" component="p">
            <FormattedMessage id="pages.token.mystery" />
          </StyledTypography>
        </StyledToolbar>
        {/* @ts-ignore */}
        <StyledList component="ul">{formatItemHtmlList(token.template?.box?.content)}</StyledList>
      </CardContent>

      <CardActions>
        <MysteryWrapperUnpackButton token={token} onRefreshPage={onRefreshPage} />
      </CardActions>
    </StyledCard>
  );
};
